import { gql } from '@apollo/client';

export const REPORT_WORKFLOW_COMPLETED_SUBSCRIPTION = gql`
  subscription interrogationReportFlowCompleted {
    interrogationReportFlowCompleted
  }
`;
